import { StatusEnumItem } from '@cims-online/shared'

/**
 * handles disabling row action buttons based on the current status of a record
 *
 * Note: Design Submittals currently use an outdated form of status enum which
 * makes them incompatible with this function, but that will change in the future
 *
 * @param action past-tense of the action performed by the button being disabled
 * @param statusItem one or more {@link StatusEnumItem | StatusEnumItems}
 * @returns a callback to evaluate disabled state based on status
 */
export function useClosedDisabledMessage<
  T extends { statusId: string },
  U extends StatusEnumItem<string, number, Lowercase<string>>
>(action: string, statusItem: U | U[]) {
  return ({ statusId }: T) => {
    const statusItems = Array.isArray(statusItem) ? statusItem : [statusItem]
    const status = statusItems.find(({ id }) => statusId === id)
    return status
      ? {
          message: `Cannot be ${action} while in status: ${status.name}`,
        }
      : false
  }
}
